<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" :title="$t('Change password')">
                <mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>

        <div class="tabs">
            <div class="tab" v-for="(item, index) in tabs" :key="index" :class="{ active: index === activeTab }"
                @click="tabClick(item, index)">{{ $t(item.gc_name) }}</div>
        </div>

        <div class="main-content">
            <div class="top-wrapper">
                <flex-line class="field-line input-wrapper" :show-border="true" :showPassword="showPassword"
                    :toggleVisibility="toggleVisibility" :isPassword="true">
                    <span class="field-name">
                        {{ $t('Old Password') }}
                    </span>
                    <div class="field-line-right" slot="right">
                        <input class="field-input" :type="showPassword ? 'text' : 'password'" v-model="old_password"
                            :placeholder="$t('Please enter')" />
                    </div>
                </flex-line>

                <!-- <flex-line class="field-line input-wrapper" :show-border="true">
                    <span class="field-name">
                        {{ $t('Verification Code') }}
                    </span>
                    <div class="field-line-right" slot="right">
                        <input class="field-input" type="number" v-model="verifyCodeMobile"
                            :placeholder="$t('Please enter')"
                            :attr="{ oninput: 'if(value.length>6)value=value.slice(0,6)' }" />
                        <div @click="sendVerifyCodeMobile" class="common-btn send-btn">{{ sendStateTextMobile }}</div>
                    </div>
                </flex-line> -->

                <flex-line class="field-line input-wrapper" :show-border="true" :showPassword="showPassword1"
                    :toggleVisibility="toggleVisibility1" :isPassword="true">
                    <span class="field-name">
                        {{ $t('New Password') }}
                    </span>
                    <div class="field-line-right" slot="right">
                        <input class="field-input" :type="showPassword1 ? 'text' : 'password'" v-model="password"
                            :placeholder="$t('Please enter')" />
                    </div>
                </flex-line>
                <flex-line class="field-line input-wrapper" :show-border="true" :showPassword="showPassword2"
                    :toggleVisibility="toggleVisibility2" :isPassword="true">
                    <span class="field-name">
                        {{ $t('Confirm Password') }}
                    </span>
                    <div class="field-line-right" slot="right">
                        <input class="field-input" :type="showPassword2 ? 'text' : 'password'" v-model="password_confirm"
                            :placeholder="$t('Please enter')" />
                    </div>
                </flex-line>

                <div class="flex" style="dmargin-top: .5rem;" v-if="activeTab == 1">
                    <div class="f balance" style="text-align: left;" @click="onRetrieve">
                        {{ $t('Forgot Password') }}?
                    </div>
                </div>

            </div>
            <div class="common-btn ds-button-large mt-10" @click="onSubmit">{{ $t('confirm') }}</div>
        </div>
    </div>
</template>

<script>
import { forget, forgetEmail, change_password } from '../../../api/memberForget'
import { getSmsCaptcha, getEmailCode, send_code_to_email } from '../../../api/common'
import { mapMutations, mapActions, mapState } from 'vuex'
import { Toast } from 'mint-ui'
import flexLine from '../../flexLine'
export default {
    name: 'MemberChangePassword',
    components: {
        flexLine
    },
    data() {
        return {
            member_name: '',
            username: '',
            confirmPassword: '',
            verifyCodeMobile: '',
            canSendMobile: true,
            timeIntervalMobile: false,
            sendStateTextMobile: this.$t('send'),
            showPassword: false,
            showPassword1: false,
            showPassword2: false,
            tabs: [
                {
                    gc_name: 'Change Login Password',
                },
                {
                    gc_name: 'Change Payment Password',
                },
            ],
            activeTab: 0,
            old_password: '',
            password: '',
            password_confirm: '',
            type: 'password',// [ password、pay_password ]
        }
    },
    beforeDestroy: function () {
        clearInterval(this.timeIntervalMobile)
    },
    mounted() {
        window.scrollTo(0, 0);
    },
    methods: {
        ...mapMutations({
            saveAuthInfo: 'memberLogin'
        }),
        onRetrieve() {
            this.$router.push({ name: 'HomeMemberForget', query: { type: 'pay_password' } })
        },
        tabClick(item, index) {
            this.activeTab = index

            this.old_password = ''
            this.password = ''
            this.password_confirm = ''

            if (index == 0) {
                this.type = 'password'
            } else {
                this.type = 'pay_password'
            }
        },
        toggleVisibility() {
            this.showPassword = !this.showPassword;
        },
        toggleVisibility1() {
            this.showPassword1 = !this.showPassword1;
        },
        toggleVisibility2() {
            this.showPassword2 = !this.showPassword2;
        },
        onSubmit() {
            if (!this.old_password || !this.password || !this.password_confirm) {
                Toast(this.$t('Please complete the form'));
                return
            }

            change_password(this.old_password, this.password, this.password_confirm, this.type).then(
                response => {
                    if (response.code == 10000) {
                        // this.saveAuthInfo({ token: response.result.token, info: response.result.info })
                        Toast(response.msg || this.$t('succ'))

                        setTimeout(() => {
                            // this.$router.push({ name: 'HomeMemberLogin' })
                            this.$router.back()
                        }, 500);
                    } else {
                        Toast(response.msg)
                    }
                },
                error => {
                    Toast(error.message)
                }
            )
            // forget(this.username, this.verifyCodeMobile, this.password, this.confirmPassword).then(
            // 	response => {
            // 		this.saveAuthInfo({ token: response.result.token, info: response.result.info })
            // 		this.$router.push({ name: 'MemberIndex' })
            // 	},
            // 	error => {
            // 		Toast(error.message)
            // 	}
            // )
        },
        sendVerifyCodeMobile() {
            if (!this.canSendMobile) {
                return
            }
            send_code_to_email().then(res => {
                this.canSendMobile = false
                let second = 60
                Toast(res.msg)
                let _this = this
                this.timeIntervalMobile = setInterval(function () {
                    if (second <= 0) {
                        _this.canSendMobile = true
                        _this.sendStateTextMobile = _this.$t('send')
                        clearInterval(_this.timeIntervalMobile)
                    } else {
                        _this.sendStateTextMobile = second + 's'
                    }

                    second--
                }, 1000)
            }).catch(function (error) {
                Toast(error.message)
            })
            // getSmsCaptcha(3, this.username).then(res => {
            // 	this.canSendMobile = false
            // 	let second = 60
            // 	Toast(res.message)
            // 	let _this = this
            // 	this.timeIntervalMobile = setInterval(function () {
            // 		if (second <= 0) {
            // 			_this.canSendMobile = true
            // 			_this.sendStateTextMobile = this.$t('send')
            // 			clearInterval(_this.timeIntervalMobile)
            // 		} else {
            // 			_this.sendStateTextMobile = second + 's'
            // 		}

            // 		second--
            // 	}, 1000)
            // }).catch(function (error) {
            // 	Toast(error.message)
            // })
        }
    }
}
</script>

<style scoped lang="scss">
.flex {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 1rem 0;

    .balance {
        font-size: .6rem;
        color: #E7010C;
        margin: 0 .5rem;
    }
}

.ds-button-large {
    width: 80%;
    margin: 1rem auto 0;
    background: #E7010C;
    padding: .2rem;
}

.container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    background: #fff;
    min-height: 100vh;
    box-sizing: border-box;

    .main-content {
        background: #fff;
        padding: 1rem 0;
    }

    .input-wrapper {
        display: flex;
        flex-direction: row;
        align-content: flex-start;
        align-items: center;
        background-color: #fff;
        // height: 2.2rem;
        // padding-left: 0.5rem;

        flex-direction: column;
        align-items: flex-start;
        margin: .4rem 0;

        .field-name {
            width: 100%;
            font-size: 14px;
            font-weight: 600;
            margin: .5rem 0;
        }

        input {
            flex: 1;
            font-size: $subFontSize;
            flex: 1;
            // width: 14.5rem;
            width: 100%;
            text-align: left;
            // border: 1px solid #cccccc;
            padding: .9rem;
            border-radius: .4rem;
            background: #FAFAFA;
            border-radius: 5px 5px 5px 5px;
        }

        .bottom-input {
            border-bottom-width: 0;
        }

        .field-line-right {
            width: 100%;
            position: relative;
        }

        ::v-deep(.right) {
            width: 100%;
        }
    }
}

.top-wrapper {
    margin: 0 1rem;
}

.bottom-wrapper {
    margin-top: 0.5rem;
}

.tips {
    color: $descTextColor;
    font-size: $fontSize;
    white-space: nowrap;
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -.3rem;
}

.field-line-right {
    position: relative
}

.send-btn {
    // border: 1px solid $primaryColor;
    color: $primaryColor;
    min-width: 2rem;
    position: absolute;
    top: 50%;
    right: .2rem;
    transform: translate(0, -50%);
}

.topList {
    height: 2rem;
    padding: 1rem $pageSpace;

    .list {
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-content: center;
        align-items: stretch;
        background-color: #fff;
    }

    .item {
        padding: 0 .5rem;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .title {
        text-align: center;
        font-size: $h2;
        color: $formInputColor;
    }

    .active {
        color: $primaryColor;
        font-size: 1.1rem;
    }

    .normal {
        color: #404245;
    }

}

.find_the_password_help {
    margin: 0 .6rem;
    font-size: $subFontSize;
    padding-top: .5rem;
    color: $descTextColor
}

.field-input {
    text-align: left !important;
}

.tabs {
    padding-left: .7rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 .5rem;
    // padding-right: 7.7rem;
    height: 2.5rem;
    background: #fff;

    .tab {
        flex: 1;
        text-align: center;
        font-size: $fontSize;
        color: #333;
        padding: 10px 12px;
    }

    .active {
        color: #fff;
        background: #E7010C;
        border-radius: 10px 10px 10px 10px;
    }
}
</style>
